import { render, staticRenderFns } from "./PaginationItem.vue?vue&type=template&id=319f6de4"
import script from "./PaginationItem.vue?vue&type=script&lang=js"
export * from "./PaginationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports